<div class="control-line mat-elevation-z8">
    <div class="filter-actions-line">
        <!-- Market (mat-select with in-panel search) -->
        <mat-form-field appearance="outline">
            <mat-label>Market</mat-label>
            <mat-select id="marketSelect" data-testid="marketSelect" [value]="selectedMarketId()"
                (selectionChange)="onMarketSelected($event.value)" (openedChange)="onMarketOpened($event)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #marketFilterInput matInput placeholder="Search markets..." [value]="marketQuery()"                       
                        (input)="onMarketQuery($event)" />
                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option *ngFor="let m of marketsFiltered(); trackBy: trackByMarketId" [value]="m.id">
                    {{ m.regionName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Customer (mat-select with in-panel search) -->
        <mat-form-field appearance="outline">
            <mat-label>Customers</mat-label>
            <mat-select id="generatorSelect" data-testid="generatorSelect" [value]="selectedGeneratorId"
                (selectionChange)="onGeneratorSelected($event.value)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #generatorFilterInput matInput placeholder="Search customer..."
                        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                        (input)="onGeneratorQuery($event)" />

                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option [value]="null">--Select Customer--</mat-option>
                @for (generator of filteredGenerators(); track generator.id) {
                    <mat-option [value]="generator.id">
                        {{ generator.customerName }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
                <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
                <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-error *ngIf="range.touched && range.hasError('required')">
              Date range is required.
            </mat-error>
            <mat-error *ngIf="range.touched && range.hasError('incompleteRange')">
              Please enter valid dates..
            </mat-error>
        </mat-form-field>

        <button id="searchTransaction" data-testid="feedStockSearchButton" mat-raised-button color="primary"
            (click)="searchToteTransactions()">
            <mat-icon>search</mat-icon>Search
        </button>
        @if(controlPermissions.addButton){
            <button id="addTransaction" data-testid="addTransaction" mat-raised-button color="primary"
                (click)="openUpsertPopup(null, 'Add')"> Add Transaction
            </button>
        }
    </div>
</div>
<div class="mat-mdc-card gridheight mat-elevation-z8 viewport mar-top-20">
    <table mat-table [dataSource]="toteTransactions" class="viewport" [trackBy]="trackByTransactionId" matSort>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let row">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openUpsertPopup(row, 'Edit')">
                        <mat-icon matListIcon>edit</mat-icon>
                        <span matLine>Edit</span>
                    </button>
                    @if(controlPermissions.duplicate){
                        <button mat-menu-item (click)="openUpsertPopup(row, 'Duplicate')">
                            <mat-icon matListIcon>content_copy</mat-icon>
                            <span matLine>Duplicate</span>
                        </button>
                    }
                    @if(controlPermissions.delete){
                        <button mat-menu-item (click)="onDelete(row.id)" style="color: red;">
                            <mat-icon matListIcon color="warn">delete</mat-icon>
                            <span matLine>Delete</span>
                        </button>
                    }
                </mat-menu>
            </td>
        </ng-container>
        <!-- ID Column -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>

        <!-- Customer Name Column -->
        <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef> Customer </th>
            <td mat-cell *matCellDef="let element"> {{element.customerName}} </td>
        </ng-container>

        <!-- Stream Name Column -->
        <ng-container matColumnDef="streamName">
            <th mat-header-cell *matHeaderCellDef> Stream </th>
            <td mat-cell *matCellDef="let element"> {{element.streamName}} </td>
        </ng-container>

        <!-- Transaction Type Column -->
        <ng-container matColumnDef="transactionType">
            <th mat-header-cell *matHeaderCellDef> Transaction Type </th>
            <td mat-cell *matCellDef="let element"> {{element.transactionType}} </td>
        </ng-container>

        <!-- Transaction Date Column -->
        <ng-container matColumnDef="transactionDate">
            <th mat-header-cell *matHeaderCellDef> Transaction Date </th>
            <td mat-cell *matCellDef="let element"> {{element.transactionDate | date:'MM/dd/yyyy'}} </td>
        </ng-container>

        <!-- Notes Column -->
        <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef> Notes </th>
            <td mat-cell *matCellDef="let element"> {{element.notes}} </td>
        </ng-container>

        <!-- Transaction Status Column -->
        <ng-container matColumnDef="transactionStatus">
            <th mat-header-cell *matHeaderCellDef> Transaction Status </th>
            <td mat-cell *matCellDef="let element"> {{element.transactionStatus}} </td>
        </ng-container>

        <!-- Fee Column -->
        <ng-container matColumnDef="fee">
            <th mat-header-cell *matHeaderCellDef> Fee </th>
            <td mat-cell *matCellDef="let element"> {{element.fee | currency}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length"
                style="color: red;text-align: center;font-weight: 500;">
                No transaction found.
            </td>
        </tr>
    </table>
</div>